import {useQuery, UseQueryResult} from '@tanstack/react-query';

import buildrzAxios from 'App/clients/buildrzAxios';
import projectQueryKeys from 'App/features/project/queries/keys';
import {TProjectGroup} from 'Pages/project/project_types';

const useProjectGroup = (
  projectGroupHash: string | null,
): UseQueryResult<TProjectGroup | undefined> =>
  useQuery({
    queryKey: projectQueryKeys.projectGroup(projectGroupHash),
    queryFn: async () => {
      const {data} = await buildrzAxios.get<TProjectGroup>(
        `projectgroups/${projectGroupHash}/`,
      );
      return data;
    },
    enabled: !!projectGroupHash,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

export default useProjectGroup;
